import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CityEffects } from './state/city.effects';
import { StoreModule } from '@ngrx/store';
import { cityFeatureKey, cityReducer } from './state/city.reducer';
import { EffectsModule } from '@ngrx/effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(cityFeatureKey, cityReducer),
    EffectsModule.forFeature([CityEffects])
  ]
})
export class CityModule { }
